import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import Seo from "./Seo";
import Breadcrumbs from "./Breadcrumbs";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-black text-white">
      <Seo />
      <Header />
      <Breadcrumbs />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
